<div class="main-content">
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header card-header-primary">
            <div class="row">
              <div class="col-8 d-flex align-items-center gap-3">
                <div>
                  <h4 class="card-title mt-0">Todo List</h4>
                  <p class="card-category">Manage your todos</p>
                </div>
                <div class="flex-grow-1" style="max-width: 300px;">
                  <app-search [(value)]="searchTerm"
                              (valueChange)="onSearchChange()"
                              placeholder="Search">
                  </app-search>
                </div>
                <mat-form-field class="todo-state-filter" appearance="outline">
                  <mat-label>State</mat-label>
                  <mat-select [(ngModel)]="stateFilter" (selectionChange)="onStateFilterChange()">
                    <mat-option [value]="TodoStateFilterEnum.All">All</mat-option>
                    <mat-option [value]="TodoStateFilterEnum.Incomplete">Incomplete</mat-option>
                    <mat-option [value]="TodoStateFilterEnum.Pending">Pending</mat-option>
                    <mat-option [value]="TodoStateFilterEnum.Overdues">Overdues</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="col-4 text-end">
                <button mat-raised-button type="button" class="btn btn-success pull-right" [routerLink]="['/todos/create']">Add New Todo</button>
              </div>
            </div>
          </div>

          <div class="card-body">
            <div class="table-responsive">
              <table class="table table-hover table-striped">
                <thead class=" text-primary">
                    <th>ID</th>
                    <th>Title</th>
                    <th>Description</th>
                    <th style="width: 130px;">Due Date</th>
                    <th>Status</th>
                    <th>Actions</th>
                </thead>
                <tbody>
                  <tr *ngFor="let todo of todos">
                    <td [style.color]="isTodoOverdue(todo) ? '#f44336' : ''">{{ todo.id }}</td>
                    <td [style.color]="isTodoOverdue(todo) ? '#f44336' : ''">{{ todo.title }}</td>
                    <td>
                      <div>
                        <div [style.color]="isTodoOverdue(todo) ? '#f44336' : ''">{{ todo.description || '-' }}</div>
                       
                        <ol *ngIf="todo.subTodos && todo.subTodos.length > 0" class="mt-2 mb-0" style="padding-left: 20px;">
                          <li *ngFor="let subTodo of todo.subTodos" 
                              style="margin-bottom: 4px;">
                            <div class="d-flex align-items-center gap-1">
                              <span [style.color]="subTodo.isDone ? '#000000' : '#f44336'"
                                    style="font-size: 14px;">
                                {{ subTodo.description || 'No description' }}
                              </span>
                              <i *ngIf="subTodo.isDone" 
                                 class="material-icons" 
                                 [style.color]="getSubTodoColor(subTodo, todo)"
                                 style="font-size: 18px; cursor: pointer; margin-left: 4px;" 
                                 (click)="uncheckSubTodo(subTodo, todo)" 
                                 title="Click to uncheck">check_box</i>
                              <i *ngIf="!subTodo.isDone" 
                                 class="material-icons" 
                                 [style.color]="getSubTodoColor(subTodo, todo)"
                                 style="font-size: 18px; cursor: pointer; margin-left: 4px;" 
                                 (click)="checkSubTodo(subTodo, todo)" 
                                 title="Click to check">check_box_outline_blank</i>
                              <i class="material-icons text-danger" 
                                 style="font-size: 16px; cursor: pointer; margin-left: 4px;" 
                                 (click)="deleteSubTodo(subTodo.id, todo.id)"
                                 title="Delete sub-todo">delete</i>
                            </div>
                          </li>
                        </ol>
                        <div style="text-align: left;">
                          <span
                            class="text-success"
                            style="
                              font-size: 15px;
                              cursor: pointer;
                              display: inline-flex;
                              align-items: center;
                              gap: 4px;
                            "
                            (click)="openAddSubTodoDialog(todo.id)"
                            title="Add sub-todo"
                          >
                            <i class="material-icons">add</i>
                            Add Sub Item
                          </span>
                        </div>
                        
                      </div>
                    </td>
                    <td [style.color]="isTodoOverdue(todo) ? '#f44336' : ''">{{ todo.dueDate ? (todo.dueDate | date:'EEE, dd-MMM-yyyy') : '-' }}</td>
                    <td [style.color]="isTodoOverdue(todo) ? '#f44336' : ''">{{ todo.isCompleted ? 'Done' : 'Pending' }}</td>
                    <td>
                      <i *ngIf="!todo.isCompleted" 
                         class="material-icons" 
                         style="cursor: pointer; color: #4caf50; font-size: 16px; margin-right: 4px;" 
                         (click)="markTodoAsCompleted(todo)" 
                         title="Mark as completed">check</i>
                      <i *ngIf="todo.isCompleted" 
                         class="material-icons" 
                         style="cursor: pointer; color: #9e9e9e; font-size: 16px; margin-right: 4px;" 
                         (click)="unmarkTodoAsCompleted(todo)" 
                         title="Mark as not completed">check_circle</i>
                      <i class="material-icons text-danger" style="cursor: pointer; margin-right: 4px;" (click)="deleteTodo(todo.id)" title="Delete">delete</i>
                      <i class="material-icons text-warning" style="cursor: pointer;" [routerLink]="['/todos/edit', todo.id]" title="Edit">edit</i>
                    </td>
                  </tr>
                </tbody>
              </table>

              <mat-paginator [length]="totalItems"
                             [pageSize]="pageSize"
                             [pageSizeOptions]="[5, 10, 25, 50]"
                             (page)="onPageChange($event)">
              </mat-paginator>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
